import { Reveal } from "./shared";

export default function OwnerQuote() {
  return (
    <section data-testid="owner-quote-section" className="mx-auto max-w-5xl px-4 pb-24 sm:px-8">
      <Reveal>
        <blockquote className="border-l-4 border-amber-500 pl-6 sm:pl-10">
          <p className="font-display text-2xl font-black italic leading-tight tracking-tight text-bone sm:text-3xl lg:text-4xl">
            “Contactless doesn't mean distant. It means I respect your time —
            and when you do text or call, you're talking straight to the guy
            holding the machine.”
          </p>
          <footer className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-amber-500">
            Eric Fisher · Owner &amp; sole operator · FridayStumps.com
          </footer>
        </blockquote>
      </Reveal>
    </section>
  );
}
